import React, { useState, useEffect, useContext } from 'react'
import { makeStyles } from '@material-ui/core/styles';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemSecondaryAction from '@material-ui/core/ListItemSecondaryAction';
import ListItemText from '@material-ui/core/ListItemText';
import IconButton from '@material-ui/core/IconButton';
import { Badge } from '@material-ui/core';
import { useHistory } from 'react-router-dom';
import { MdNotifications } from "react-icons/md";
import LogContext from 'context/log/logContext';
import CircularProgress from '@material-ui/core/CircularProgress';

function MenuNotificaciones({ close }) {
    const history = useHistory();
    const classes = useStyles();
    const logContext = useContext(LogContext);
    const { obtenerLogs } = logContext;

    const redirectAlertas = () => {
        history.push("/supervisor")
        close()
    }

    const redirectInactividad = () => {
        history.push("/nodos-inactividad")
        close()
    }
    const [cantAlertas, setCantAlertas] = useState()
    const [cantInactividad, setCantInactividad] = useState()
    const [loadingAlertas, setLoadingAlertas] = useState(true)
    const [loadingInactividad, setLoadingInactividad] = useState(true)

    const setBadgets = () => {
        setLoadingAlertas(true)
        setLoadingInactividad(true)
        obtenerLogs(null, "count", "alertas").then(alertas => {
            try {
                const count = alertas.cantidadNotificacionesAlertas
                if (count) {
                    setCantAlertas(count > 99 ? "99+" : count)
                }
                setLoadingAlertas(false)
            }catch(e){}
        })
        obtenerLogs(null, "count", "inactividad").then(inactividad => {
            try {
                const count = inactividad.cantidadNotificacionesInactividad
                if (count) {
                    setCantInactividad(count > 99 ? "99+" : count)
                }
                setLoadingInactividad(false)   
            }catch(e){}
        })
    }
    useEffect(() => {
        setBadgets()
    }, [])

    return (
        <div className={classes.root}>
            <List dense={false}>
                <ListItem
                    className={classes.listItem}
                    onClick={redirectAlertas}
                >
                    <ListItemText
                        primary="Alertas"
                    />
                    <ListItemSecondaryAction>
                        {loadingAlertas ?
                            <CircularProgress size={20} style={{marginRight: "1em"}}/>
                            :
                            <IconButton edge="end" aria-label="delete" className={classes.iconList} >
                                <Badge badgeContent={cantAlertas} color="secondary">
                                    <MdNotifications />
                                </Badge>
                            </IconButton>
                        }
                    </ListItemSecondaryAction>
                </ListItem>
                <ListItem
                    className={classes.listItem}
                    onClick={redirectInactividad}
                >
                    <ListItemText
                        primary="Inactividad"
                    />
                    <ListItemSecondaryAction>
                        {loadingInactividad ?
                            <CircularProgress size={20} style={{marginRight: "1em"}}/>
                            :
                            <IconButton edge="end" aria-label="delete" className={classes.iconList}>
                                <Badge badgeContent={cantInactividad} color="secondary">
                                    <MdNotifications />
                                </Badge>
                            </IconButton>
                        }
                    </ListItemSecondaryAction>
                </ListItem>
            </List>
        </div>
    )
}

export default MenuNotificaciones

const useStyles = makeStyles((theme) => ({
    root: {
        //backgroundColor: theme.palette.background.paper,
        //padding: ".5em",
        minWidth: 200,
    },
    listItem: {
        cursor: "pointer",
        paddingRight: "1em",
        borderRadius: "4px",
        "&:hover": {
            backgroundColor: "rgba(146, 146, 146, 0.1)"
        },
        zIndex: "2!important"
    },
    iconList: {
        color: "#666",
        paddingRight: "1em",
        zIndex: "1!important"
    }
}));